import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendJobForm, resetJobFormState } from "../../redux/JobFormSlice";
import "./JobForm.css";
import CheckEmpty from "../../Assets/Svg/Jobs/CheckEmpty.svg";
import CheckFilled from "../../Assets/Svg/Jobs/CheckFill.svg";
export default function JobsForm() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.jobForm);
  const formRef = useRef();
  const [captcha, setCaptcha] = useState("");
  const [userCaptchaInput, setUserCaptchaInput] = useState("");
  const [isCaptchaOpen, setIsCaptchaOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [agreeTerms1, setAgreeTerms1] = useState(false);
  const [agreeTerms2, setAgreeTerms2] = useState(false);
  const [uploadedCV, setUploadedCV] = useState(null);
  const [uploadedCoverLetter, setUploadedCoverLetter] = useState(null);
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  //

  useEffect(() => {
    generateCaptcha();
    dispatch(resetJobFormState());
  }, [dispatch]);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptcha(`${num1} + ${num2}`);
  };

  const validateName = (value) => {
    if (value.trim().length < 3) {
      setNameError("Name must be at least 3 characters long.");
    } else {
      setNameError("");
    }
  };

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value.trim())) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };
  const validatePhone = (value) => {
    if (value.trim().length < 11) {
      setPhoneError("Phone enter a valid Phone number");
    } else {
      setPhoneError("");
    }
  };
  //

  const validateInputs = (formData, updatedAgreeTerms1 = agreeTerms1, updatedAgreeTerms2 = agreeTerms2) => {
    const name = formData.get("user_name").trim();
    const email = formData.get("user_email").trim();
    const phone = formData.get("user_phone").trim();

    return (
      name.length >= 3 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && phone.length >= 3 && updatedAgreeTerms1 && updatedAgreeTerms2 && uploadedCV // Resume/CV is required
    );
  };

  const handleFileChangeCv = (e) => {
    const file = e.target.files[0];
    if (file && file.size < 2 * 1024 * 1024) {
      setUploadedCV(file);
    } else {
      alert("File is too large or not valid.");
    }
  };

  const handleFileChangeLetterFile = (e) => {
    const file = e.target.files[0];
    if (file && file.size < 2 * 1024 * 1024) {
      setUploadedCoverLetter(file);
    } else {
      alert("File is too large or not valid.");
    }
  };

  const sendEmailAfterVerification = (e) => {
    e.preventDefault();
    const form = formRef.current;
    if (!form) return;

    const formData = new FormData(form);
    if (!validateInputs(formData)) return;

    setIsCaptchaOpen(true);
  };

  const verifyCaptchaAndSendEmail = async () => {
    const captchaValues = captcha.split(" + ").map(Number);
    const correctCaptchaAnswer = captchaValues[0] + captchaValues[1];

    if (parseInt(userCaptchaInput) !== correctCaptchaAnswer) {
      alert("Captcha verification failed. Please try again.");
      return;
    }

    try {
      const form = formRef.current;
      const formData = new FormData(form);

      const payload = {
        name: formData.get("user_name"),
        email: formData.get("user_email"),
        phone: formData.get("user_phone"),
        address: formData.get("user_address"),
        message: formData.get("user_message"),
        position_id: 1,
        resume: null,
        cover_letter: null,
      };

      if (uploadedCV) {
        payload.resume = ("resume", uploadedCV);
      }

      if (uploadedCoverLetter) {
        payload.cover_letter = ("cover_letter", uploadedCoverLetter);
      }

      await dispatch(sendJobForm(payload)).unwrap();
      setIsSuccess(true);
      setUserCaptchaInput("");
      setCaptcha("");
      setUploadedCV(null);
      setUploadedCoverLetter(null);
      setIsFormValid(false);
      form.reset();
      generateCaptcha();
    } catch (err) {
      console.error("Form submission failed:", err);
      if (typeof err === "object" && err.errors) {
        const allErrors = Object.values(err.errors).flat().join("\n");
        alert(allErrors);
      } else {
        alert("Something went wrong. Please try again.");
      }
    }
  };

  const enforceWordLimit = (event, maxWords) => {
    const textarea = event.target;
    const words = textarea.value.trim().split(/\s+/);
    if (words.length > maxWords) {
      textarea.value = words.slice(0, maxWords).join(" ");
      alert(`You can only enter up to ${maxWords} words.`);
    }
  };

  const checkFormValidity = () => {
    const form = formRef.current;
    if (!form) return false;

    const formData = new FormData(form);
    setIsFormValid(validateInputs(formData));
  };

  const toggleAgreeTerms1 = () => {
    setAgreeTerms1((prev) => {
      const newState = !prev;
      // Call checkFormValidity with the updated state
      checkFormValidityWithUpdatedTerms(newState, agreeTerms2);
      return newState;
    });
  };
  const toggleAgreeTerms2 = () => {
    setAgreeTerms2((prev) => {
      const newState = !prev;
      // Call checkFormValidity with the updated state
      checkFormValidityWithUpdatedTerms(agreeTerms1, newState);
      return newState;
    });
  };

  const checkFormValidityWithUpdatedTerms = (updatedAgreeTerms1, updatedAgreeTerms2) => {
    const form = formRef.current;
    if (!form) return;

    const formData = new FormData(form);
    setIsFormValid(validateInputs(formData, updatedAgreeTerms1, updatedAgreeTerms2));
  };

  return (
    <>
      <div className="JobsS5">
        <form ref={formRef} onSubmit={sendEmailAfterVerification} onChange={checkFormValidity}>
          <div className="ContactUsBig">
            <div className="JobFormWebContainer">
              <div className="JobFormWTC">
                <div className="JobFormWP1">
                  <div className="FiledBoxContainer">
                    <InputFieldBox
                      InputType="input"
                      Type="text"
                      Name="Full Name"
                      name="user_name"
                      Required="(required)"
                      Placeholder="Name"
                      InputWidth="34.5vw"
                      onBlur={(e) => validateName(e.target.value)}
                    />
                    {nameError && <div className="error-message TF16PxSC">{nameError}</div>}
                  </div>
                  <div className="FiledBoxContainer">
                    <InputFieldBox
                      InputType="input"
                      Type="email"
                      Name="Email"
                      name="user_email"
                      Required="(required)"
                      Placeholder="example@gmail.com"
                      InputWidth="34.5vw"
                      onBlur={(e) => validateEmail(e.target.value)}
                    />
                    {emailError && <div className="error-message TF16PxSC">{emailError}</div>}
                  </div>
                  <div className="FiledBoxContainer">
                    <InputFieldBox
                      InputType="input"
                      Type="text"
                      Name="Phone Number"
                      name="user_phone"
                      Required="(required)"
                      Placeholder="+20"
                      Height=""
                      InputWidth="34.5vw"
                      onBlur={(e) => validatePhone(e.target.value)}
                    />
                    {phoneError && <div className="error-message TF16PxSC">{phoneError}</div>}
                  </div>
                  <InputFieldBox
                    InputType="input"
                    Type="text"
                    Name="Address"
                    name="user_address"
                    Required="(optional)"
                    Placeholder="Your current city of residence"
                    Height=""
                    InputWidth="34.5vw"
                  />
                </div>
                <div className="FormWP1">
                  <InputFieldBoxUploadCV
                    InputType="input"
                    Type="text"
                    Name="Upload CV"
                    name="resume"
                    Required="(File upload, PDF/Word format)"
                    Placeholder="Select a file"
                    InputWithButton={true}
                    InputWidth="23vw"
                    ButtonText="Choose File"
                    onFileChange={handleFileChangeCv}
                    fileName={uploadedCV?.name}
                  />
                  <InputFieldBoxUploadCL
                    InputType="input"
                    Type="file"
                    Name="Upload Cover Letter"
                    name="cover_letter"
                    Required="(Optional)"
                    Placeholder="Maximum size is 2 MB"
                    InputWithButton={true}
                    InputWidth="23vw"
                    ButtonText="Choose File"
                    onFileChange={handleFileChangeLetterFile}
                    fileName={uploadedCoverLetter?.name}
                  />
                  <InputFieldBox
                    InputType="textarea"
                    Type="text"
                    Name="Message"
                    name="user_message"
                    Required="(Optional)"
                    Placeholder="Your message to us, including any details or questions"
                    onInput={(e) => enforceWordLimit(e, 1000)}
                    maxLength={1000}
                    TextAreaHeight="12.3vw"
                  />
                </div>
              </div>
              <div className="JobTerms">
                <div className="JobTermsP1 TFut24PxPC">Agreement</div>
                <div className="JobTermsP2 TFut20PxPC">
                  <button type="button" onClick={toggleAgreeTerms1}>
                    <img src={agreeTerms1 ? CheckFilled : CheckEmpty} alt="checkbox" className="CheckFilledImg" />
                  </button>
                  I agree to the terms and conditions
                </div>
                <div className="JobTermsP2 TFut20PxPC">
                  <button type="button" onClick={toggleAgreeTerms2}>
                    <img src={agreeTerms2 ? CheckFilled : CheckEmpty} alt="checkbox" className="CheckFilledImg" />
                  </button>
                  I consent to my data being used for recruitment purposes
                </div>
              </div>
            </div>
            {/*  */}
            {/*  */}
            {/* Captcha Pop-up */}
            {isCaptchaOpen && (
              <CaptchaModal
                captcha={captcha}
                userCaptchaInput={userCaptchaInput}
                setUserCaptchaInput={setUserCaptchaInput}
                onCancel={() => {
                  setIsCaptchaOpen(false);
                  setUserCaptchaInput("");
                  generateCaptcha();
                }}
                onVerify={verifyCaptchaAndSendEmail}
                isLoading={loading}
                isSuccess={isSuccess}
              />
            )}
            {/*  */}
            {/*  */}
          </div>
          <div className="JobsS6">
            <div className="JobsS6P1 TF20PxSC">To submit a Request fill job form.</div>
            <div className="JobsS6P2">
              <button
                className="JobFromWsubmitB TFut16PxPCUC"
                type="submit"
                style={{ opacity: isFormValid ? 1 : 0.2, cursor: isFormValid ? "pointer" : "not-allowed" }}
                disabled={loading}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

function InputFieldBox({
  InputType,
  InputWidth,
  InputWidthMob,
  TextAreaHeight,
  TextAreaHeightMob,
  InputWithButton,
  Type,
  Name,
  Required,
  Placeholder,
  name,
  ButtonText,
  onFileChange,
  onBlur,
}) {
  const isMobile = window.innerWidth <= 768;
  const fileInputRef = useRef();

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="JobInputFieldBox">
      <div className="JobIFBT">
        <div className="JobIFBTN TFut24PxPC">{Name}</div>
        <div className="JobIFBTR TFut16PxPCUC">{Required}</div>
      </div>
      <div className="JobIFBContent">
        <InputType
          type={Type}
          name={name}
          placeholder={Placeholder}
          className="JobIFBI TFut20PxPC"
          style={{ width: isMobile ? InputWidthMob : InputWidth, height: isMobile ? TextAreaHeightMob : TextAreaHeight }}
          onBlur={onBlur}
        />
        {InputWithButton && (
          <>
            <button type="button" className="JobIFBButton TFut16PxPCUC" onClick={handleButtonClick}>
              {ButtonText}
            </button>
            <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={onFileChange} accept=".pdf,.doc,.docx" />
          </>
        )}
      </div>
    </div>
  );
}

//
// For Cv
//
function InputFieldBoxUploadCV({
  InputType,
  InputWidth,
  InputWidthMob,
  TextAreaHeight,
  TextAreaHeightMob,
  InputWithButton,
  Type,
  Name,
  Required,
  Placeholder,
  name,
  ButtonText,
  onFileChange,
  fileName,
}) {
  const isMobile = window.innerWidth <= 768;
  const fileInputRef = useRef();

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="JobInputFieldBox">
      <div className="JobIFBT">
        <div className="JobIFBTN TFut24PxPC">{Name}</div>
        <div className="JobIFBTR TFut16PxPCUC">{Required}</div>
      </div>
      <div className="JobIFBContent">
        <InputType
          type={Type}
          name={name}
          placeholder={Placeholder}
          className="JobIFBI TFut20PxPC"
          style={{ width: isMobile ? InputWidthMob : InputWidth, height: isMobile ? TextAreaHeightMob : TextAreaHeight }}
          value={fileName || ""}
          readOnly={InputWithButton}
        />
        {InputWithButton && (
          <>
            <button type="button" className="JobIFBButton TFut16PxPCUC" onClick={handleButtonClick}>
              {ButtonText}
            </button>
            <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={onFileChange} accept=".pdf,.doc,.docx" />
          </>
        )}
      </div>
    </div>
  );
}

//
// For CL
//
function InputFieldBoxUploadCL({
  InputType,
  InputWidth,
  InputWidthMob,
  TextAreaHeight,
  TextAreaHeightMob,
  InputWithButton,
  Type,
  Name,
  Required,
  Placeholder,
  name,
  ButtonText,
  onFileChange,
  fileName,
}) {
  const isMobile = window.innerWidth <= 768;
  const fileInputRef = useRef();

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="JobInputFieldBox">
      <div className="JobIFBT">
        <div className="JobIFBTN TFut24PxPC">{Name}</div>
        <div className="JobIFBTR TFut16PxPCUC">{Required}</div>
      </div>
      <div className="JobIFBContent">
        <InputType
          type="text"
          name={name}
          placeholder={Placeholder}
          className="JobIFBI TFut20PxPC"
          style={{ width: isMobile ? InputWidthMob : InputWidth, height: isMobile ? TextAreaHeightMob : TextAreaHeight }}
          value={fileName || ""}
          readOnly={InputWithButton}
        />
        {InputWithButton && (
          <>
            <button type="button" className="JobIFBButton TFut16PxPCUC" onClick={handleButtonClick}>
              {ButtonText}
            </button>
            <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={onFileChange} accept=".pdf,.doc,.docx" />
          </>
        )}
      </div>
    </div>
  );
}

function CaptchaModal({ captcha, userCaptchaInput, setUserCaptchaInput, onVerify, onCancel, isLoading, isSuccess }) {
  return (
    <div className="captchaModal">
      <div className="captchaModalContent">
        {isLoading ? (
          <div className="CPLoading TFut16PxPCUC">Loading...</div>
        ) : isSuccess ? (
          <div className="CaptchaSubmit">
            <div className="CPMessage TFut16PxPCUC">Thanks, your message was sent. We'll get back to you soon.</div>
            <button onClick={onCancel} className="CaptchaSubB TFut16PxPCUC">
              Close
            </button>
          </div>
        ) : (
          <div className="CaptchaQAContainer">
            <div className="CaptchaQ">
              <div className="CaptchaQP1 TGLo32PxPC">Human Verification</div>
              <div className="CaptchaQP2 TFut16PxPCUC">What is {captcha}?</div>
            </div>
            <div className="CaptchaAA">
              <input
                type="text"
                className="CaptchaAnswerF TFut16PxPCUC"
                placeholder="_"
                value={userCaptchaInput}
                onChange={(e) => setUserCaptchaInput(e.target.value)}
              />
              <div className="CaptchaBB">
                <button onClick={onCancel} className="CaptchaC TFut16PxPCUC">
                  Cancel
                </button>
                <button onClick={onVerify} className="CaptchaV TFut16PxPCUC">
                  Verify
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
